import React from "react";
import { INicu } from "../types/interfaces/INicu";
import { CardContent, Grid, Typography } from "@mui/material";

//This function creates a card for a nicu address.
export default function NicuDetailAddressCard(props: {nicu: INicu}) {
    return (
        <React.Fragment>
            <CardContent>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
                    <Grid item xs={4}>
                        <Typography variant="h6">Address:</Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography>{props.nicu.AddressLine1}</Typography>
                        <Typography display="block">{props.nicu.AddressLine2}</Typography>
                        <Typography display="block">{props.nicu.AddressLine3}</Typography>
                        <Typography display="block">{props.nicu.AddressLine4}</Typography>
                        <Typography display="block">{props.nicu.City}, {props.nicu.State} {props.nicu.Zip}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant="h6">Phone:</Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography>{props.nicu.Phone}</Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </React.Fragment>
    );
}